// extracted by mini-css-extract-plugin
module.exports = {"map":"Map-module--map--2H1js"};